import Register from './Modules/register';

const Modules = {
  Register
};

export default Modules;
